
import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";

import {CONST} from '../../environments/environment'

// 1つのアプリケーションに属する環境の数（Web環境＋DBコネクト環境。現時点では2固定）
export const NUMBER_OF_ENV = 2

// 環境一覧取得APIの実行用
export async function executeGetAccount(){
	let session = await fetchAuthSession();
	let api_name = CONST.API_NAME;
	let path = CONST.API_PATH.ACCOUNT;
	let myInit = {
		headers: {
			Authorization: session.tokens?.idToken?.toString()
		},
		queryParams: {
			accessToken: session.tokens?.accessToken?.toString(),
		}
	};
	let response = await get({
		apiName: api_name,
		path,
		options: myInit
	}).response;
    response = await response.body.json();
	
	if ("errorMessage" in response) {
		throw response;
	}
	return response
}

// ### 